
import { Component, Prop, Vue } from "vue-property-decorator";
import { Question } from "@/lib/model/question/question";
import { QuestionV2 } from "@/lib/model/exambuilder/question-v2";
@Component
export default class TooltipMaterials extends Vue {
  @Prop({ required: true })
  question!: QuestionV2 | Question; //题目
  @Prop({ default: "body", type: String }) main!: string;
  @Prop({ default: 2 }) padding!: number;
  // 开启指定弹框范围设置为true
  @Prop({ default: false, type: Boolean }) range!: boolean;

  isPlaying = false;

  mounted() {
    console.log("here!!!!!!");
    console.log(this.question);
  }

  playAudioDesc() {
    const audioElements = Array.from(document.querySelectorAll("audio"));
    const currentAudio = audioElements.find(
      audioElement => audioElement.id === `player${this.question.questionId}`
    );

    if (currentAudio && !currentAudio.paused) {
      //此音频正在播放，则暂停
      currentAudio.pause();
      this.isPlaying = false;
      return;
    } else {
      this.$emit("playAudioDesc", this.question);
      this.isPlaying = true;
    }
  }
  get classStr() {
    return `materials appendDesc2${this.question.questionId}`;
  }
  // 特判显示popover  滚动时依然存在问题
  show(ele: string, isImg = false) {
    if (this.range) {
      const main = document.querySelector(this.main) as HTMLElement;
      const appendDesc = document.querySelector(ele) as HTMLElement;
      this.$nextTick(() => {
        const mainLeft = main.offsetLeft;
        const mainRight = mainLeft + main.offsetWidth;
        const tooltipLeft = appendDesc.offsetLeft;
        const tooltipRight = tooltipLeft + appendDesc.offsetWidth;
        if (mainLeft > tooltipLeft) {
          appendDesc.style.left = `${mainLeft + this.padding}px`;
        } else if (mainRight < tooltipRight) {
          appendDesc.style.left = `${mainRight -
            appendDesc.offsetWidth -
            this.padding}px`;
        } else {
          appendDesc.style.left = `${tooltipLeft}px`;
        }
      });
    }
    isImg && this.setloginImg();
  }
  setloginImg() {
    this.$nextTick(() => {
      const toolTip = document.querySelector(
        `.id${this.question.questionId}`
      ) as HTMLElement;
      if (toolTip) {
        const imgList = toolTip.querySelectorAll("img");
        if (imgList && imgList.length > 0) {
          // 当前有效屏宽为，实际屏宽 - 内边距（8*2）
          const clientWidth = toolTip.clientWidth - 16;
          imgList.forEach(img => {
            img.style["zoom"] = String(clientWidth / img.width);
          });
        }
      }
    });
  }
}
